<template>
  <vs-row>
    <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem"> Add New Banner </vs-button>
    <vs-row>
      <vs-col class="d-flex drop-width mb-3" vs-lg="2" vs-xs="12">
        <vs-select label="Language Filter" v-model="search.language" @change="searchData()">
          <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
        </vs-select>
      </vs-col>
      <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
        <vs-select label="Sorting Type" v-model="search.sort" @change="searchData()">
          <vs-select-item value text="Select Sorting" disabled />
          <vs-select-item value="ASC" text="Ascending" />
          <vs-select-item value="DESC" text="Descending" />
        </vs-select>
      </vs-col>
      <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
        <vs-select label="Status Filter" v-model="search.status" @change="searchData()">
          <vs-select-item value text="Select Status" disabled />
          <vs-select-item value="0" text="All" />
          <vs-select-item value="1" text="Active" />
          <vs-select-item value="2" text="Inactive" />
        </vs-select>
      </vs-col>
      <vs-col class="d-flex drop-width" vs-lg="2" vs-xs="12">
        <vs-select label="Day Filter" v-model="search.isToday" @change="searchData()">
          <vs-select-item value text="Select Day" disabled />
          <vs-select-item value="false" text="All" />
          <vs-select-item value="true" text="Today" />
        </vs-select>
      </vs-col>
      <vs-col vs-lg="4" vs-xs="12">
        <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
                icon="search">Search</vs-button> -->
        <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()">Reset</vs-button>
      </vs-col>
    </vs-row>
    <br />
    <table class="table">
      <tr>
        <th>#</th>
        <td></td>
        <th>Title</th>
        <th>Description</th>
        <th>KeyValue Pairs</th>
        <th>Status</th>
        <th></th>
      </tr>
      <tr v-for="(item, index) in all" :key="item._id">
        <td class="td">{{ index + 1 }}</td>
        <td>
          <img v-if="all.length && !item.image" src="../../../../assets/images/No-image.png" height="50px" width="75px" />
          <img v-if="all.length && item.image" :src="item.image" height="50px" width="75px" />
        </td>
        <td class="td">
          {{ item.title }}<br />Position - {{ item.position }}<br />Language - {{ item.language }}<br />
          <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
            <div class="progress-bar-container mt-3">
              <div
                class="progress-bar p-2"
                :style="{
                  color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                  backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                  width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                }"
              >
                <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
              </div>
            </div>
            <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
              <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"></circle>
                  <line x1="12" y1="16" x2="12" y2="12"></line>
                  <line x1="12" y1="8" x2="12" y2="8"></line>
                </svg>
              </div>
            </div>
          </div>
        </td>
        <td class="td text-center">
          <span class="material-icons eye" @click="viewBannerDetails(item)">remove_red_eye</span>
        </td>
        <td class="td text-center">
          <span class="material-icons eye" @click="viewKeyValuePairs(item)">remove_red_eye</span>
        </td>
        <td class="td">
          <vs-chip v-if="item.status" color="success">Active</vs-chip>
          <vs-chip v-else color="danger">Inactive</vs-chip>
        </td>
        <td class="td">
          <vs-button class="mr15 mt-1" icon="create" size="small" color="warning" @click="editingItem(item, 'edit')">Edit</vs-button>
          <vs-button
            class="mr15 mt-1"
            size="small"
            color="danger"
            icon="delete_sweep"
            @click="
              deleteBannerPopup = true;
              itemToDelete = item;
            "
            >Delete</vs-button
          >
        </td>
      </tr>
    </table>

    <!-- Code -->
    <vs-popup :title="'Add New Banner'" :active.sync="defaultalert">
      <vs-row>
        <vs-col vs-lg="12" vs-xs="12">
          <vs-select
            label="Language Filter"
            @change="fileterusingLanguage($event, banner)"
            v-model="banner.language"
            icon="arrow_downward"
            :disabled="isNew"
          >
            <!-- <vs-select-item value text="All Languages" /> -->
            <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
          </vs-select>
        </vs-col>
        <!-- title -->
        <vs-col vs-lg="12" vs-xs="12">
          <vs-input label="Banner Title (Keep it Simple and short)" v-model="banner.title" />
        </vs-col>
        <!-- desc -->
        <vs-col vs-lg="12" vs-xs="12">
          <label>Banner Description</label>
          <vs-textarea width="100%" v-model="banner.description" />
        </vs-col>
        <!-- position -->
        <vs-col vs-lg="12" vs-xs="12">
          <vs-input
            type="number"
            label="Banner Position (Try to assign different position)"
            :min="1"
            :max="all.length + 1"
            v-model="banner.position"
          />
        </vs-col>
        <!-- link -->
        <vs-col vs-lg="12" vs-xs="12">
          <vs-input label="Banner LInk" v-model="banner.link" />
        </vs-col>
        <!-- status -->
        <vs-col vs-lg="5" vs-xs="6" class="mt-2">
          <vs-checkbox v-model="banner.status">Status (Active / Inactive)</vs-checkbox>
        </vs-col>
        <!-- image -->
        <vs-col vs-lg="12" vs-xs="12" class="mt-3">
          <div>
            <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
              <div class="upload-btn-wrapper vs-input-primary">
                <label class="vs-input--label">Banner Image (Try to use rectangle image)</label>
                <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                <input type="file" ref="fileInput" @change="uploadImage($event)" />
              </div>
            </vs-col>
            <vs-col v-if="displayImage">
              <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
              <img :src="displayImage" class="imgUp" height="100px" width="150px" />
              <b v-if="fileName">File Name : {{ fileName }}</b>
            </vs-col>
          </div>
        </vs-col>
        <!-- custom key value pairs -->
        <vs-row class="px-3 mb-3" vs-align="center">
          <label class="vs-input--label" style="margin-top: 0.5cm">Custom Key Data: {{ banner.customKeyValuePairs.length || 0 }}</label>
          <div
            style="display: flex; align-items: center; gap: 0.5cm; width: 100%"
            v-for="(keyValuePair, index) in banner.customKeyValuePairs"
            :key="index"
          >
            <vs-input v-model="keyValuePair.key" label="Key" class="mt-3" />
            <vs-input v-model="keyValuePair.value" label="Value" class="mt-3" />
            <div style="display: flex; align-items: center; gap: 0.1cm">
              <vs-button icon="delete" @click="removeCustomKey(index)" color="danger" class="mt-3" style="border-radius: 50%; z-index: 0" />
            </div>
          </div>
          <vs-row vs-align="center" vs-justify="center" v-if="banner.customKeyValuePairs.length < 8">
            <vs-button icon="add" @click="addCustomKey" color="primary" class="mt-3" style="z-index: 1">Add pair</vs-button>
          </vs-row>
        </vs-row>
        <!-- start date -->
        <vs-col vs-lg="4" vs-xs="6">
          <label>Start Date</label>
          <br />
          <datepicker placeholder="Start Date" v-model="banner.startDate" format="yyyy-MM-dd" class="zIndexClass"> </datepicker>
        </vs-col>
        <!-- end date -->
        <vs-col vs-lg="4" vs-xs="6">
          <label>End Date</label>
          <br />
          <datepicker placeholder="End Date" v-model="banner.endDate" format="yyyy-MM-dd" class="form-group"> </datepicker>
        </vs-col>
        <!-- buttons -->
        <vs-col vs-lg="9" vs-xs="12" class="mt-2">
          <vs-button icon="save" style="z-index: 1" @click="btnAddBanner">{{ isNew ? "Save English" : "Update one" }}</vs-button>
          <vs-button class="ml-3" icon="save" style="z-index: 1" v-if="isNew" @click="createAndTranslate">Save and Translate</vs-button>
          <vs-button class="ml-3" icon="save" style="z-index: 1" v-if="!showLoader && !isNew && banner.language === 'EN'" @click="updateAndTranslate"
            >Update all</vs-button
          >
          <vs-checkbox class="mt-2" style="z-index: 1" v-model="banner.translate" v-if="!isNew && banner.language === 'EN'"
            >Update translations</vs-checkbox
          >
        </vs-col>
      </vs-row>
    </vs-popup>

    <vs-popup class="holamundo" title="Delete Banner" :active.sync="deleteBannerPopup">
      <p>Are you sure you want to delete Banner?</p>
      <div>
        <vs-button icon="delete_forever" class="mr15" @click="deleteBanner">Delete Banner</vs-button>
        <vs-button icon="clear" @click="deleteBannerPopup = false">Cancel</vs-button>
      </div>
    </vs-popup>

    <vs-popup title="View Description" :active.sync="viewDetails">
      <div>
        <h6>Description :</h6>
        <p>{{ detail.description }}</p>
        <h6 v-if="detail.link">Link :</h6>
        <p>{{ detail.link }}</p>
      </div>
    </vs-popup>

    <vs-popup title="View KeyValue Pairs" :active.sync="viewKeyPairs">
      <div v-html="desc"></div>
    </vs-popup>

    <!-- Code -->

    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import Datepicker from "vuejs-datepicker";
import Vue from "vue";
import VPopover from "vue-js-popover";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "sBanner",
  components: {
    Datepicker,
  },
  data: () => ({
    title: "sBanner",
    defaultalert: false,
    viewDetails: false,
    deleteBannerPopup: false,
    isNew: true,
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
      isToday: "false",
    },
    displayImage: "",
    fileName: "",
    banner: {
      status: true,
      language: "EN",
      position: "",
      title: "",
      image: "",
      customKeyValuePairs: [{ key: "", value: "" }],
      translate: false,
      description: "",
      endDate: "",
      startDate: "",
      link: "",
    },
    desc: "",
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    detail: {},
    showLoader: false,
    viewKeyPairs: false,
  }),
  methods: {
    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.banner = {
        status: true,
        isRepeat: false,
        language: "EN",
        position: "",
        title: "",
        image: "",
        customKeyValuePairs: [{ key: "", value: "" }],
        translate: false,
        description: "",
        endDate: "",
        startDate: "",
        link: "",
      };
      this.$data.displayImage = "";
      this.$data.fileName = "";
    },

    editingItem(i, data) {
      this.$data.banner = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.image;
    },

    addCustomKey() {
      this.$data.banner.customKeyValuePairs.push({ key: "", value: "" });
    },

    removeCustomKey(index) {
      this.$data.banner.customKeyValuePairs.splice(index, 1);
    },

    async btnAddBanner() {
      this.$vs.loading();
      this.$data.banner.image = this.$data.displayImage;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      if (this.$data.isNew) {
        try {
          const r = await api.post(API.ADD_BANNER, this.$data.banner, { headers });
          if (r.status === 200) {
            this.$vs.notify({
              title: "Banner Added",
              text: "Banner Added Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.defaultalert = false;
            await this.searchData();
            this.$data.banner = {
              status: true,
              isRepeat: false,
              language: "EN",
              position: "",
              title: "",
              image: "",
              customKeyValuePairs: [{ key: "", value: "" }],
              translate: false,
              description: "",
              endDate: "",
              startDate: "",
              link: "",
            };
            this.$data.displayImage = "";
            this.$data.fileName = "";
          }
        } catch (error) {
          console.error(error);
          this.$vs.notify({
            title: "Error adding banner",
            text: error,
            color: "danger",
            position: "top-right",
          });
        } finally {
          this.$vs.loading.close();
        }
      } else {
        const data = { ...this.$data.banner };
        delete data.translate;
        try {
          const r = await api.put(API.GET_SHOP_BANNER_PLAIN + "/" + this.$data.banner._id, data, { headers });
          if (r.status === 200) {
            this.$data.defaultalert = false;
            this.$vs.notify({
              title: "Banner Updated",
              text: "Banner Updated Successfully",
              color: "success",
              position: "top-right",
            });
            await this.searchData();
            this.$data.banner = {
              status: true,
              isRepeat: false,
              language: "EN",
              position: "",
              title: "",
              image: "",
              customKeyValuePairs: [{ key: "", value: "" }],
              translate: false,
              description: "",
              endDate: "",
              startDate: "",
              link: "",
            };
            this.$data.displayImage = "";
            this.$data.fileName = "";
          }
        } catch (error) {
          console.error(error);
          this.$vs.notify({
            title: "Error updating banner",
            text: error,
            color: "danger",
            position: "top-right",
          });
        } finally {
          this.$vs.loading.close();
        }
      }
    },

    async createAndTranslate() {
      this.$vs.loading();
      this.$data.showLoader = true;
      this.$data.banner.image = this.$data.displayImage;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      try {
        const r = await api.post(API.C_AND_T_SHOP_BANNER, this.$data.banner, { headers });
        if (r.status === 200) {
          this.$vs.notify({
            title: "Banner Added",
            text: "Banner Added Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.defaultalert = false;
          await this.searchData();
          this.$data.banner = {
            status: true,
            isRepeat: false,
            language: "EN",
            position: "",
            title: "",
            image: "",
            customKeyValuePairs: [{ key: "", value: "" }],
            translate: false,
            description: "",
            endDate: "",
            startDate: "",
            link: "",
          };
          this.$data.displayImage = "";
          this.$data.fileName = "";
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error adding banner",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        this.$data.showLoader = false;
      }
    },

    async updateAndTranslate() {
      this.$vs.loading();
      this.$data.showLoader = true;
      this.$data.banner.image = this.$data.displayImage;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      try {
        const r = await api.put(API.U_AND_T_SHOP_BANNER + "/" + this.$data.banner._id, this.$data.banner, { headers });
        if (r.status === 200) {
          this.$vs.notify({
            title: "Banner Updated",
            text: "Banner Updated Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.defaultalert = false;
          await this.searchData();
          this.$data.banner = {
            status: true,
            isRepeat: false,
            language: "EN",
            position: "",
            title: "",
            image: "",
            customKeyValuePairs: [{ key: "", value: "" }],
            translate: false,
            description: "",
            endDate: "",
            startDate: "",
            link: "",
          };
          this.$data.displayImage = "";
          this.$data.fileName = "";
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error updating banner",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$data.showLoader = false;
        this.$vs.loading.close();
      }
    },

    async deleteBanner() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      try {
        const r = await api.delete(API.GET_SHOP_BANNER_PLAIN + "/" + this.$data.itemToDelete._id, { headers });
        if (r.status === 200) {
          this.$vs.notify({
            title: "Banner Deleted",
            text: "Banner Deleted Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.deleteBannerPopup = false;
          await this.searchData();
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error deleting banner",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async fileterusingLanguage(event, item) {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-18",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      try {
        if (event) {
          let id = item.ref || item._id;

          const r = await api.get(`${API.GET_SINGLE_SHOP_BANNER}/${id}?language=${event}`, { headers });

          if (r.status === 200) {
            this.$data.banner = Object.assign({}, r.data);
            this.$data.displayImage = r.data.image;
          }
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error fetching data",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async uploadImage(data) {
      if (data.target.files[0].type != "image/jpeg" && data.target.files[0].type != "image/jpg" && data.target.files[0].type != "image/webp") {
        return this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG or JPG Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
      } else if (data.target.files[0].size > 500000) {
        return this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
      }

      this.$vs.loading();
      try {
        let formdata = new FormData();
        this.$data.fileName = data.target.files[0].name;
        formdata.append("file", data.target.files[0]);
        formdata.append("banner", this.$data.banner.title);

        const r = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (r.status === 200) {
          this.$data.displayImage = r.data.files[0].url;
          this.$vs.notify({
            title: "File Uploaded",
            text: "File Uploaded Successfully",
            color: "success",
            position: "top-right",
          });
          this.$refs.fileInput.value = null;
          this.$emit("input", data);
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error uploading image",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    deleteImage() {
      this.$data.displayImage = "";
    },

    async fetchAllLanguages() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        if (r) this.$data.languages = r.data;
      } catch (error) {
        console.error(error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async searchData() {
      this.$vs.loading();
      try {
        const r = await api.get(
          `${API.GET_SHOP_BANNER}?sort=${this.$data.search.sort}&language=${this.$data.search.language}&status=${this.$data.search.status}&isToday=${this.$data.search.isToday}`
        );
        if (r.status === 200) {
          await Promise.all(
            r.data.map(async (item) => {
              item.tooltipContent =
                item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
            })
          );
          this.$data.all = r.data;
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          title: "Error fetching data",
          text: error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "1",
        isToday: "false",
      };
      this.searchData();
    },

    viewBannerDetails(i) {
      this.$data.detail.description = i.description;
      this.$data.detail.link = i.link;
      this.$data.viewDetails = true;
    },

    viewKeyValuePairs(item) {
      this.$data.viewKeyPairs = true;
      this.$data.banner = item;

      let tableRows = "";
      item.customKeyValuePairs.forEach((pair) => {
        console.log(pair);

        tableRows += `<tr>
      <td style="padding: 5px; border: 1px solid #ddd;">${pair.key}</td>
      <td style="padding: 5px; border: 1px solid #ddd;">${pair.value}</td>
    </tr>`;
      });

      this.$data.desc = `<div>
    <table style="width: 100%; border-collapse: collapse; text-align: left;">
      <thead>
        <tr>
          <th style="padding: 8px; border: 1px solid #ddd;">Key</th>
          <th style="padding: 8px; border: 1px solid #ddd;">Value</th>
        </tr>
      </thead>
      <tbody>
        ${tableRows}
      </tbody>
    </table>
  </div>`;
    },
  },
  created() {
    this.searchData();
    this.fetchAllLanguages();
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 10px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.eye {
  cursor: pointer;
  margin: auto;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

td {
  padding: 0.5rem;
}

.drop-width {
  width: 150px !important;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
